import React, {Component, Fragment} from 'react'
import Select, {components as selectComponents} from 'react-select'
import memoize from 'lodash/memoize'

import {RadioGroup, RadioInput} from 'components/radio'
import ChangeEmail from 'components/change-email'
import InputContainer from './InputContainer'
import InputTextView from './InputTextView'
import InputSelectView from './InputSelectView'
import InputDropdownIndicator from './InputDropdownIndicator'
import SelectInput from './SelectInput'
import AutoSuggest from './autosuggest'
import TextAreaInput from './TextAreaInput'

class Input extends Component {
  findCachedSelectOption = memoize((value, options) => this.findSelectOption(value, options))

  formatOptionLabel = (event, field) => {
    const fullString = event.label
    const input = field.inputValue

    if (!input) {
      return fullString
    }

    const arr = fullString.toLowerCase().split(input.toLowerCase())

    if (arr.length < 2) {
      return fullString
    }

    const start = arr[0].length
    const end = start + input.length
    return (
      <Fragment>
        <Fragment>{fullString.slice(0, start)}</Fragment>
        <b>{fullString.slice(start, end)}</b>
        <Fragment>{fullString.slice(end)}</Fragment>
      </Fragment>
    )
  }

  findSelectOption = (value, options) => options.find(option => option.value === value)

  onSelectKeyDown = ({key}) => {
    if (key === 'Enter') {
      this.selectRef.setState({menuIsOpen: true})
    }
  }

  render() {
    const {
      value,
      error,
      label,
      radio,
      name,
      onChange,
      className,
      select,
      highlight,
      options,
      text,
      selectView,
      menuList,
      selectWrapper,
      inline,
      focused,
      profile,
      autoSuggest,
      textarea,
      email,
      notUseCache,
      autoOptionHeight,
      ...props
    } = this.props

    if (select) {
      const View = selectView || InputSelectView

      const selectValue = notUseCache
        ? this.findSelectOption(value, options)
        : this.findCachedSelectOption(value, options) || null

      // TODO unite styles props into one prop
      return (
        <View
          autoOptionHeight={autoOptionHeight}
          error={error}
          className={className}
          focused={focused}
          backgroundColor={props.inputBackgroundColor}
          borderRight={props.inputBorderRight}
          focusBorderRight={props.inputFocusBorderRight}
          hoverBorderRight={props.inputHoverBorderRight}
          errorBorderRight={props.inputErrorBorderRight}>
          <Select
            components={{
              DropdownIndicator: InputDropdownIndicator,
              Input: SelectInput,
              MenuList: menuList || selectComponents.MenuList,
              Control: selectWrapper || selectComponents.Control,
            }}
            ref={el => {
              this.selectRef = el
            }}
            onKeyDown={this.onSelectKeyDown}
            value={selectValue}
            name={name}
            options={options}
            formatOptionLabel={highlight ? this.formatOptionLabel : undefined}
            classNamePrefix="select"
            onChange={onChange}
            profile={profile}
            {...props}
          />
        </View>
      )
    }

    if (autoSuggest) {
      return (
        <AutoSuggest
          error={error}
          value={value}
          name={name}
          onChange={onChange}
          className={className}
          focused={focused}
          {...props}
        />
      )
    }

    if (radio) {
      return (
        <RadioGroup
          name={name}
          selectedValue={value}
          onChange={onChange}
          onBlur={props.onBlur}
          vertical={props.vertical}>
          {props.values.map(({value, label, disabled}) => (
            <RadioInput key={value} value={value} error={error} inline={inline} disabled={disabled}>
              {label}
            </RadioInput>
          ))}
        </RadioGroup>
      )
    }

    if (text) {
      return (
        <InputTextView className={className} {...props}>
          {value}
        </InputTextView>
      )
    }

    if (email) {
      return <ChangeEmail onChange={onChange} value={value} {...props} />
    }

    if (textarea) {
      return (
        <TextAreaInput
          error={error}
          value={value}
          name={name}
          onChange={onChange}
          className={className}
          focused={focused}
          {...props}
        />
      )
    }

    return (
      <InputContainer
        error={error}
        value={value}
        name={name}
        onChange={onChange}
        className={className}
        focused={focused}
        {...props}
      />
    )
  }
}

export default Input
